import { deepClone } from './object';

const intersect = (a, b) => {
	const inter = [];
	const inA = {};
	let i = 0;

	for (i = 0; i < a.length; i += 1) {
		inA[a[i]] = true;
	}
	for (i = 0; i < b.length; i += 1) {
		if (inA[b[i]]) inter[inter.length] = b[i];
	}
	return inter;
};

const unique = (a) => {
	const na = [];

	// eslint-disable-next-line
	lbl:for (let i = 0; i < a.length; i += 1) {
		for (let j = 0; j < na.length; j += 1) {
			if (na[j] === a[i]) continue lbl; // eslint-disable-line no-continue, no-labels
		}
		na[na.length] = a[i];
	}
	return na;
};

// Is in array a but not b
const differenceLeft = (a, b) => (
	a.filter((i) => b.indexOf(i) < 0)
);

// Symmeterical if a not in b and b not in a.
const difference = (a, b) => {
	const la = a.length;
	const lb = b.length;
	const res = [];
	let i;

	if (!la) return b;
	if (!lb) return a;

	for (i = 0; i < la; i += 1) {
		if (b.indexOf(a[i]) === -1) res[res.length] = a[i];
	}
	for (i = 0; i < lb; i += 1) {
		if (a.indexOf(b[i]) === -1) res[res.length] = b[i];
	}
	return res;
};

const flatten = (arr) => (
	arr.reduce((flat, toFlatten) => (
		flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten)
	), [])
);

const shuffle = (b, seed) => {
	const a = deepClone(b);
	for (let i = a.length - 1; i > 0; i -= 1) {
		const random = seed && Array.isArray(seed) ? seed[i % seed.length] : Math.random();
		const j = Math.floor(random * (i + 1));
		const x = a[i];
		a[i] = a[j];
		a[j] = x;
	}
	return a;
};

const arraysEqual = (a, b) => {
	if (Array.isArray(a) && Array.isArray(b)) {
		if (a.length !== b.length) return false;
		for (let i = 0; i < a.length; i += 1) {
			if (!arraysEqual(a[i], b[i])) return false;
		}
		return true;
	}
	return a === b;
};

const fillArray = (length, func = () => {}) => [...Array(length)].map((a, b) => func(a, b));

export { intersect, unique, flatten, difference, differenceLeft, shuffle, arraysEqual, fillArray };
